/**
 * These are configuration settings for the production environment.
 *
 * Do not include API secrets in this file or anywhere in your JS.
 *
 * https://reactnative.dev/docs/security#storing-sensitive-info
 */
// export default {
//   API_URL: "https://myai-prod-backend.whitebay-72880d9c.eastus.azurecontainerapps.io/",
//   AUTH_URL: "https://myai-prod-backend.whitebay-72880d9c.eastus.azurecontainerapps.io/auth",
//   USER_URL: "https://myai-prod-backend.whitebay-72880d9c.eastus.azurecontainerapps.io/users",
//   PARENT_URL: "https://myai-prod-backend.whitebay-72880d9c.eastus.azurecontainerapps.io/users/parent",
//   CHAT_URL: "https://myai-prod-backend.whitebay-72880d9c.eastus.azurecontainerapps.io/users/chat",
//   DOCUMENTS_URL: "https://myai-prod-backend.whitebay-72880d9c.eastus.azurecontainerapps.io/users/documents",
//   ADMIN_URL: "https://myai-prod-backend.whitebay-72880d9c.eastus.azurecontainerapps.io/admin",
//   PAYMENTS_URL: "https://myai-prod-backend.whitebay-72880d9c.eastus.azurecontainerapps.io/payment",
//   STRIPE_URL:
//     "pk_live_51NGEFwGYepGhH2d4A45tpZEn6ZiEuTOHhSPYnvODCFv4U3YVq6xBiKFQgxhcNVDsQte5LFA5SLkMNN6W1s0Ry6ON001rpCdBPG",
//   WEBPUBSUB_URL: "wss://myai-prod-web-pubsub.webpubsub.azure.com/client/hubs/notification?access_token="

// }

export default {
  API_URL:
    "https://myai-dev-backend.gentleglacier-b729e979.eastus.azurecontainerapps.io/",
  AUTH_URL:
    "https://myai-dev-backend.gentleglacier-b729e979.eastus.azurecontainerapps.io/auth",
  USER_URL:
    "https://myai-dev-backend.gentleglacier-b729e979.eastus.azurecontainerapps.io/users",
  PARENT_URL:
    "https://myai-dev-backend.gentleglacier-b729e979.eastus.azurecontainerapps.io/users/parent",
  CHAT_URL:
    "https://myai-dev-backend.gentleglacier-b729e979.eastus.azurecontainerapps.io/users/chat",
  DOCUMENTS_URL:
    "https://myai-dev-backend.gentleglacier-b729e979.eastus.azurecontainerapps.io/users/documents",
  ADMIN_URL:
    "https://myai-dev-backend.gentleglacier-b729e979.eastus.azurecontainerapps.io/admin",
  PAYMENTS_URL:
    "https://myai-dev-backend.gentleglacier-b729e979.eastus.azurecontainerapps.io/payment",
  STRIPE_URL:
    "pk_test_51NahCaLZXSqXiVXjozTuuFZokQQpPh6P8OrXpm8bfNwN2CCy65ZzEhbancBlIOO959raMLxJQvTWnpx9uBb259Xx00mdvwiOuN",
  WEBPUBSUB_URL:
    "wss://myai-dev-web-pubsub.webpubsub.azure.com/client/hubs/notification?access_token=",
};

// export default {
//   API_URL:
//     "http://localhost:8000/",
//   AUTH_URL:
//     "http://localhost:8000/auth",
//   USER_URL:
//     "http://localhost:8000/users",
//   PARENT_URL:
//     "http://localhost:8000/users/parent",
//   CHAT_URL:
//     "http://localhost:8000/users/chat",
//   DOCUMENTS_URL:
//     "http://localhost:8000/users/documents",
//   ADMIN_URL:
//     "http://localhost:8000/admin",
//   PAYMENTS_URL:
//     "http://localhost:8000/payment",
//   STRIPE_URL:
//     "pk_test_51NahCaLZXSqXiVXjozTuuFZokQQpPh6P8OrXpm8bfNwN2CCy65ZzEhbancBlIOO959raMLxJQvTWnpx9uBb259Xx00mdvwiOuN",
//   WEBPUBSUB_URL:
//     "wss://myai-dev-web-pubsub.webpubsub.azure.com/client/hubs/notification?access_token=",
// };
